import ScalarListboxItem_vue_vue_type_script_setup_true_lang_default from "./ScalarListboxItem.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarListbox/ScalarListboxItem.vue
var ScalarListboxItem_default = ScalarListboxItem_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarListboxItem_default as default };

//# sourceMappingURL=ScalarListboxItem.vue.js.map